export default {
  HANDLE_SUCCESS_GET_CHART_DATA: 'handleSuccessGetChartData',
  HANDLE_FETCHING_CHART_DATA: 'handleFetchingChartData',
  HANDLE_SUCCESS_GET_SUMMARY_DATA: 'handleGetSummaryData',
  HANDLE_FETCHING_SUMMARY_DATA: 'handleFetchingSummaryData',
  HANDLE_QUICK_LINK_CHANGE: 'handleQuickLinkChange',
  TOGGLE_BANNER_PREVIEW_MODAL: 'toggleBannerPreviewModal',
  HANDLE_DASHBOARD_CAMPAIGN_CHANGE: 'handleDashboardCampaignChange',
};



// WEBPACK FOOTER //
// ./src/app/main/dashboard/constants/action-types.js